import * as yup from 'yup';

export const PinLoginSchema = yup.object({
  pin: yup.string().min(4, 'Pin always has 4 digits').required('Pin is required'),
});

export type IPinLogin = yup.InferType<typeof PinLoginSchema>;
